import useUserInformation from "../hooks/useUserInformation";

// Simple HOC to make sure userInformation doesn't get null, to Wrap with pages
// only where most of userInformation is required
const withUserInformation = (WrappedComponent) => {
  const WithUserInformation = (props) => {
    useUserInformation({ setUser: props?.setUser });
    return <WrappedComponent {...props} />;
  };

  return WithUserInformation;
};

export default withUserInformation;
